import React from 'react';
import { Card, CardTitle, Icon } from 'react-materialize';

function Home() {

    return (
        <React.Fragment>
            <section className='home filter'>
                <br />
                <div className='title-principal'>
                    <h1>Calm Yoga</h1>
                    <p>Yoga is balance, order, precision and well-being.</p>
                </div>
                <br />
            </section>
            <section className='services filter'>

                <div className='list'>

                    <Card
                        closeIcon={<Icon>Close</Icon>}
                        header={<CardTitle image="https://images.pexels.com/photos/4056723/pexels-photo-4056723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" reveal waves="light" />}
                        reveal={<p>We have a wide variety of specialized teachers available for all areas of yoga,
                            anyone regardless of their age can attend our lessons, either in person or online</p>
                        }
                        revealIcon={<Icon>🡩</Icon>}
                        title="Classes with great teachers"
                    >
                        <p>
                            <a href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">
                                view
                            </a>
                        </p>
                    </Card>

                    <Card
                        closeIcon={<Icon>Close</Icon>}
                        header={<CardTitle image="https://images.pexels.com/photos/1761279/pexels-photo-1761279.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" reveal waves="light" />}
                        reveal={<p>
                            Finding the right path to clear our minds and be able to
                            know ourselves and the path to follow to improve our lives can be difficult depending on each person,
                            since each one is a world, we invite you to be part of our motivational talks while you walk by relaxing natural landscapes
                        </p>
                        }
                        revealIcon={<Icon>🡩</Icon>}
                        title="Find the way"
                    >
                        <p>
                            <a href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">
                                view
                            </a>
                        </p>
                    </Card>

                    <Card
                        closeIcon={<Icon>Close</Icon>}
                        header={<CardTitle image="https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" reveal waves="light" />}
                        reveal={<p>Deep breathing. <br />
                            Massage.<br />
                            Meditation.<br />
                            Tai chi.<br />
                            Yoga.<br />
                            Biofeedback.<br />
                            Music and art therapy.<br />
                            Aromatherapy.<br /></p>
                        }
                        revealIcon={<Icon>🡩</Icon>}
                        title="Relaxation techniques"
                    >
                        <p>
                            <a href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">
                                view
                            </a>
                        </p>
                    </Card>

                    <Card
                        closeIcon={<Icon>Close</Icon>}
                        header={<CardTitle image="https://images.pexels.com/photos/1234035/pexels-photo-1234035.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" reveal waves="light" />}
                        reveal={<p>
                            It does not matter the place or the moment of your life, you can meditate and do yoga anywhere, do not miss the opportunity,
                            it is time to unload all that tiredness and bad energy,
                            you can start now and in your favorite place, contact us and we will soon we will be visiting to advise you
                        </p>
                        }
                        revealIcon={<Icon>🡩</Icon>}
                        title="The right place can be anywhere"
                    >
                        <p>
                            <a href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">
                                view
                            </a>
                        </p>
                    </Card>

                </div>

            </section>
        </React.Fragment>
    );


}
export default Home;